import {GameModuleResponse} from './GameModuleResponse';
import {GameModules} from '../GameModules';

/**
 * @class GameModuleGambleResponse - game module response type of module "gamble", eq: ResponseBase->modules["gamble"].
 */
export class GameModuleGambleResponse extends GameModuleResponse {
    /**
     * @property previousCards - List of previously drawn cards. For explanation of values see Gamble introduction.
     */
    previousCards: Array<string>;

    /**
     * @property currentWin - Current value of the win (and max current bet in gamble).
     */
    currentWin: number;

    /**
     * @property currentCard - Current win card. Used only in response to select request. For explanation of values see Gamble introduction.
     */
    currentCard: string;

    /**
     * @property colorWin - Possible win for color choice.
     */
    colorWin: number;

    /**
     * @property suitWin - Possible win for suit choice. Used only if suit mode is enabled.
     */
    suitWin: number;

    /**
     * @property halveEnabled - Determines if player can halve current win amount.
     */
    halveEnabled: boolean;

    protected internalValidate(errors: Array<string>): void {
        // TODO(psulek) add check of other required properties...
    }

    public moduleName(): string {
        return GameModules.Gamble;
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/GameModuleGambleResponse.ts
 **/